import { useLazyQuery } from "@apollo/client/react";import { useState, useEffect } from 'react';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material';
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import { CustomButton } from "../../../../../components/customButton/CustomButton";
import { TextInput } from "../../../../../components/textInput/TextInput";
import toast from 'react-hot-toast';
import { GET_USER_BY_CREDENTIALS } from '../../../../../data/graphQL/queries/Reclamos/getUserByCredentials';
import { GetDescripcionMensaje } from '../../../../../helpers/tools';

export const PasswordModal = ({
  isLoading,
  cierraFlujo,
  onSubmit
}) => {
  const [openDlgPass, setOpenDlgPass] = useState(false);
  const [password, setPassword] = useState('');
  const [state, setState] = useState({ ShowPass: false });
  const [ipClient, setIpClient] = useState('');
  const [pcClient, setPcClient] = useState('');
  const [latitud, setLatitud] = useState('');
  const [longitud, setLongitud] = useState('');
  const SITE_KEY = "6LfF9G0hAAAAAFM28HVcb_SBUziY62eUUQEB7Wjq";

  const handleChange = (value) => setPassword(value);

  const [getUsuario, { data: dataUsuario, loading }] = useLazyQuery(GET_USER_BY_CREDENTIALS, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {
    if (!dataUsuario || loading) return;
    if (dataUsuario.login.success) {
      if (dataUsuario.login.valorEsperado.valido) {
        onSubmit();
      }
    } else
    {
      let descripcionError = GetDescripcionMensaje(dataUsuario.login.error);
      if (isNaN(descripcionError)) {
        let mensaje = `${dataUsuario.login.error} - ${descripcionError}`;
        toast.error(mensaje);
      } else {
        toast.error(descripcionError);
      }
    }
    setOpenDlgPass(false);
  }, [dataUsuario]);

  const cargarGeolocalizacion = () => {
    if (!navigator.geolocation)
    alert("Este navegador no soporta la geolocalización");else
    {
      const onUbicacionConcedida = (ubicacion) => {
        const coordenadas = ubicacion.coords;
        const latitud = coordenadas.latitude;
        const longitud = coordenadas.longitude;

        setLatitud(latitud);
        setLongitud(longitud);
      };

      const onErrorDeUbicacion = (error) => {
        let mensajeError;
        switch (error.code) {
          case 0:
            mensajeError = "Permiso denegado por el usuario.";
            break;
          case 1:
            mensajeError = "Posicion no disponible.";
            break;
          case 2:
            mensajeError = "Desconexion por tiempo.";
            break;
          case 3:
            mensajeError = "Error desconocido.";
            break;
        }
      };

      const opcionesDeSolicitud = {
        enableHighAccuracy: true, // Alta precisión
        maximumAge: 0, // sin cache
        timeout: 5000 // Esperar solo 5 segundos
      };

      navigator.geolocation.getCurrentPosition(onUbicacionConcedida, onErrorDeUbicacion, opcionesDeSolicitud);
    }
  };

  useEffect(() => {
    fetch('https://api.ipify.org?format=json').
    then((results) => results.json()).
    then((data) => setIpClient(data.ip)).
    catch((e) => console.log(e));

    cargarGeolocalizacion();

    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
    });
  }, []);

  const executeQuery = async (token) => {
    const usuario = sessionStorage.getItem('usuario');

    let result = await getUsuario(
      {
        variables: {
          usuario: usuario.toLowerCase(),
          clave: password,
          token: token,
          ipUsuario: ipClient,
          pcUsuario: pcClient,
          longitud: longitud.toString(),
          latitud: latitud.toString()
        }
      });
  };

  const handleClick = async () => {

    window?.grecaptcha?.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: 'signup' }).then((token) => {
        executeQuery(token);
      });
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter')
    handleAceptar();
  };

  const handleSave = () => {
    if (cierraFlujo)
    setOpenDlgPass(true);else

    onSubmit();
  };

  const handleAceptar = () => {
    if (isFormValid())
    handleClick();
  };

  const isFormValid = () => {
    if (password.length === 0) {
      toast.error("Debe ingresar su contraseña");
      return false;
    }

    return true;
  };

  const onCloseDlgPass = () => setOpenDlgPass(false);

  const handleClickShowPassword = () => {
    setState({
      ...state,
      ShowPass: !state.ShowPass
    });
  };
  return <>
        <CustomButton
      label='Guardar'
      disabled={false}
      onClick={() => handleSave()}
      isLoading={isLoading}
      variant='contained' />
    
        <CustomDialog
      maxWidth="sm"
      fullWidth={true}
      open={openDlgPass}
      title={'Ingrese tu contraseña'}
      cancelLoading={loading}
      acceptLoading={loading}
      onCancel={onCloseDlgPass}
      onAccept={handleAceptar}>
      
            <div className='dialog-content'>
                <TextInput
          name='password'
          label='Contraseña'
          value={password}
          onChange={(e) => handleChange(e.target.value)}
          onKeyDown={handleKeyDown}
          type={state.ShowPass ? 'text' : 'password'}
          customProps={{
            endAdornment:
            <InputAdornment position="end">
                                <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                edge="end">
                
                                    {state.ShowPass ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>

          }} />
        
            </div>
        </CustomDialog>
    </>;
};